import React from 'react';
import { useTranslation } from 'react-i18next';
import BadgeIcon from '../../assets/icons/BadgeIcon';
import { Text, ListInfoWrapper } from './DealersSelector.styles';

interface DealersListProps {
  within: number;
  selectedNumber: number;
}

const DealersList: React.FC<DealersListProps> = ({ within, selectedNumber }) => {
  const { t } = useTranslation();

  return (
    <>
      <ListInfoWrapper>
        <Text>
          {t('dealerLocationSearch.dealersList.dealersWithinRadius')}: <span>{within}</span>
        </Text>
        <BadgeIcon />
        <Text>
          {t('dealerLocationSearch.dealersList.filter')}: <span>{selectedNumber}</span>
        </Text>
      </ListInfoWrapper>
    </>
  );
};

export default DealersList;
